import moment from "moment";

export const dateToIso = (date: string, format = 'DD-MM-YYYY') => {
    return moment.utc(date, format).startOf('day').add(11, 'hours').toISOString();
 };